 
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DiscountOfferItemsResponseEntity } from '../../domain/entities/DiscountOfferItemsResponseEntity'
import { ItemMiniModel } from '@/features/item/data/models/ItemMiniModel'
import type { ItemEntity } from '@/features/item/domain/entities/ItemEntity'

export class DiscountOfferItemsResponseModel extends DiscountOfferItemsResponseEntity {
  constructor(dataDto: DiscountOfferItemsResponseEntity) {
    super()
    const itemMiniModel = dataDto.items?.map((item: ItemEntity) => new ItemMiniModel(item))
    mapEntityProperties<DiscountOfferItemsResponseEntity>(this, dataDto, {
      map: {
        items: itemMiniModel
      }
    })
  }
}
